import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui';
import LocationOn from 'material-ui-icons/LocationOn';

const styles = theme => ({
    tinyhotelcard: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        width: 380,
        height: 124,
        padding: 4,
        zIndex: 10000,
    },

    image: {
        width: 100,
        height: 120,
        border: '1px solid red',
        float: 'left',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        transition: 'background - image 1s ease-in -out',
        backgroundPosition: 'center center'
    },
    hotel: {
        border: '1px solid blue',
        paddingLeft: 110,
    },

    name: {
        fontSize: 14,
        color: 'red',
        fontWeight: 'bold'
    },

    town: {
        fontSize: 10
    },

    offers: {
        height: 40
    },
    onrequest: {
        textAlign: 'left',
        float: 'left'
    },
    priceleyend: {
        textAlign: 'right'
    },

    number: {
        fontWeight: 400,
        fontSize: 24
    },

    onRequestMarker: {
        width: 32,
        height: 32,
        color: '#d6731c',
        position: 'absolute',
        top: -24,
        left: -12
    },
    availMarker: {
        width: 32,
        height: 32,
        color: '#2ca90e',
        position: 'absolute',
        top: -24,
        left: -12
    }
});

class ResultMapMarker extends React.Component {
    render() {
        const { classes, hotel } = this.props;
        return (<div
            style={{
                cursor: this.props.onClick ? 'pointer' : 'default',
                width: 8,
                height: 8,
            }}
            alt={this.props.text}
            onClick={this.props.onClick ? this.props.onClick : ''}>
            <LocationOn className={hotel && hotel.onrequest ? classes.onRequestMarker : classes.availMarker} />
        </div >
        );
    }
}

ResultMapMarker.defaultProps = {
    onClick: null,
};

ResultMapMarker.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
};

export default withStyles(styles)(ResultMapMarker);


// WEBPACK FOOTER //
// ./src/components/Results/ResultMapMarker.js